import { getBroccoliHarvestOptimiserSupabase } from "../../../consts/supabaseClient.js";

export async function fetchActualYieldTable(siteId) {
  const supabase = getBroccoliHarvestOptimiserSupabase();
  const TABLE = "Actual Yield Table";
  let { data, error } = await supabase.from(TABLE).select("*").eq("site", siteId);

  if (error) {
    console.error("Error fetching actual yield data:", error);
    return [];
  }

  return data;
}

export async function fetchLookupWithConfig(siteId) {
  const supabase = getBroccoliHarvestOptimiserSupabase();
  const VIEW = "harvest_with_config";
  const PAGE_SIZE = 1000;
  let allData = [];
  let offset = 0;
  let hasMore = true;

  while (hasMore) {
    let { data, error } = await supabase
      .from(VIEW)
      .select("*")
      .eq("site", siteId)
      .range(offset, offset + PAGE_SIZE - 1);

    if (error) {
      console.error("Error fetching harvest_with_config record data:", error);
      return [];
    }

    if (!data || data.length === 0) {
      hasMore = false;
    } else {
      allData = allData.concat(data);
      if (data.length < PAGE_SIZE) {
        hasMore = false;
      }
      offset += PAGE_SIZE;
    }
  }

  return allData;
}

export async function fetchSiteConfig(siteId) {
  const supabase = getBroccoliHarvestOptimiserSupabase();
  const TABLE = "Site Config";

  let { data, error } = await supabase.from(TABLE).select("*").eq("site", siteId);

  if (error) {
    console.error("Error fetching site config data:", error);
    return [];
  }

  return data;
}

export async function fetchHarvestConstraints(siteId) {
  const supabase = getBroccoliHarvestOptimiserSupabase();
  const TABLE = "Config Record";

  let { data, error } = await supabase
    .from(TABLE)
    .select("*")
    .eq("site", siteId)

  if (error) {
    console.error("Error fetching site config data:", error);
    return [];
  }

  return data;
}

export async function setHarvestConstraints(siteName, constraints) {
  const supabase = getBroccoliHarvestOptimiserSupabase();
  const { data, error } = await supabase
    .from("Site Config")
    .update({
      harvest_pass_gap: constraints.max_pass_gap_days,
      area_harvestable_per_day_ha: constraints.area_harvestable_per_day_ha,
      max_location_per_day: constraints.max_location_per_day,
      event_per_day: constraints.events_per_day,
      non_harvest_dates: constraints.non_harvest_dates,
    })
    .eq("site", siteName)
    .select();

  if (error) {
    console.error("Error in updating site config data:", error);
    return [];
  }

  return data;
}

export async function setSpecSize(siteName, constraints) {
  const supabase = getBroccoliHarvestOptimiserSupabase();
  const { data, error } = await supabase
    .from("Site Config")
    .update({
      minimum_spec_size: constraints.minimum_spec_size,
      maximum_spec_size: constraints.maximum_spec_size,
    })
    .eq("site", siteName)
    .select();

  if (error) {
    console.error("Error in updating site config data:", error);
    return [];
  }

  return data;
}
